import { type TokenTextColor } from '@volkswagen-onehub/components-core';
import { HTMLAttributes, ReactNode } from 'react';
import { StyledButtonIcon } from './ButtonIcon.styles';

export interface ButtonIconProps extends HTMLAttributes<HTMLSpanElement> {
  icon: ReactNode;
  raised?: boolean;
  iconColor?: TokenTextColor;
  iconFill?: TokenTextColor;
}

const ButtonIcon = ({ icon, ...restProps }: ButtonIconProps) => {
  return <StyledButtonIcon {...restProps}>{icon}</StyledButtonIcon>;
};

export default ButtonIcon;
